function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.101 17.896v1.7c0 .222.178.404.405.404h19.32a.406.406 0 00.405-.405v-1.7a.406.406 0 00-.405-.404H.506a.403.403 0 00-.405.405zM.405 6.267h19.328a.403.403 0 00.405-.405V4.79a.403.403 0 00-.23-.368L10.503.04a.39.39 0 00-.336-.004L.238 4.418A.405.405 0 000 4.79v1.072c0 .223.182.405.405.405zM2.084 15.282a.403.403 0 00-.405.405v.995h4.56v-.995a.406.406 0 00-.404-.405H5.6v-6.81h.235a.403.403 0 00.404-.404v-.992H1.68v.992a.4.4 0 00.405.404h.23v6.81h-.23zM14.307 15.282a.403.403 0 00-.404.405v.995h4.556v-.995a.403.403 0 00-.405-.405h-.23v-6.81h.23a.4.4 0 00.405-.404v-.992h-4.556v.992a.4.4 0 00.404.404h.231v6.81h-.23zM8.194 15.282a.406.406 0 00-.405.405v.995h4.56v-.995a.406.406 0 00-.405-.405h-.23v-6.81h.23a.403.403 0 00.405-.404v-.992H7.79v.992c0 .226.182.404.405.404h.23v6.81h-.23z",
  fill: "#404040"
});

function SvgBankIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBankIcon;